// extracted by mini-css-extract-plugin
export default {"root":"yykiJvfH3m3TK2Z_ROaq","text":"ZHtjn8CgLrwOuSd235SY","restoreBtnWrapper":"Aw8TDfiCKHpNWC57MlD_"};